module.exports = __webpack_public_path__ + "static/media/login.a2a55acf.png";